// @flow
import * as constants from './constants';

import { createAction } from 'redux-actions';

export const setBoostHeatingHotwater = createAction(constants.SET_BOOST_HEATING_HOTWATER);
export const setHotWaterStatus = createAction(constants.SET_HOT_WATER_STATUS);
export const setHotWaterStatusSuccessful = createAction(constants.SET_HOT_WATER_STATUS_SUCCESSFUL);
export const setHotWaterStatusUpdateProduct = createAction(constants.SET_HOT_WATER_STATUS_UPDATE_PRODUCT);
export const stopBoostHeatingHotwater = createAction(constants.STOP_BOOST_HEATING_HOTWATER);
export const timeoutBoostHeatingHotwater = createAction(constants.TIMEOUT_BOOST_HEATING_HOTWATER);
export const toggleHotWater = createAction(constants.TOGGLE_HOT_WATER);
export const toggleHotWaterDone = createAction(constants.TOGGLE_HOT_WATER_DONE);



// WEBPACK FOOTER //
// ./src/core/state/products/heating-hotwater/actions.js